import axios from "axios";
import {store} from "../index";
import SETTINGS from "../../settings";
import {getCSRFToken} from "../../allauth/lib/django";

const ax = axios.create({
    baseURL: SETTINGS.baseAPIUrl,
    withCredentials: true
});

// add the header to the request
ax.interceptors.request.use(
    (config) => {
        //add the token;
        const state = store.getState();
        const accessToken = state.session.accessToken;
        // console.log("ACCESS CHECK", accessToken, state.session)
        // console.log("REFRESH CHECK", state.session.refreshToken)
        if (accessToken && accessToken !== "obsoletetoken") {
            config.headers["Authorization"] = "Bearer " + accessToken;
        }

        const csrfToken = getCSRFToken();
        const allheaders = config.headers;
        if (csrfToken) {
            allheaders["X-CSRFToken"] = csrfToken;
        }

        const campaign = state.session.focusedCampaign.id;
        //campaign param on every outgoing call.
        if (!config.params) config.params = {};
        config.params = {...config.params, campaign};
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


export default {
    get(url, params) {
        return ax
            .get(url, {params})
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },

    post(url, request) {
        return ax
            .post(url, {...request})
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },

    patch(url, request) {
        return ax
            .patch(url, {...request})
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
 

    delete(url, request) {
        return ax
            .delete(url)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
};
